module.exports = __webpack_public_path__ + "images/next/recruiting_services/logo-fdd4d2be1bda5699b279c81825e4ef5b.png";